module.exports = __webpack_public_path__ + "static/media/stm-21st-tablet-1476x114-@1x.55365142.webp";